'use client';

import {
  MotionContainer,
  varBounce,
} from '@/components/minimal-components/animate';
import CompactLayout from '@/features/layouts/dashboard/components/compact';
import PageNotFoundIllustration from '@/features/layouts/dashboard/components/notfound/not-found-illustrations';
import { useLocales } from '@/locales';
import { RouterLink } from '@/routes/components';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { m } from 'framer-motion';

export default function NotFoundView() {
  const { t } = useLocales();
  return (
    <CompactLayout>
      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            {t('layouts.errors.notFoundMessage')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {t('layouts.errors.notFoundDescription')}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <PageNotFoundIllustration
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>

        <Button
          component={RouterLink}
          href="/dashboard/app"
          color="primary"
          variant="contained"
        >
          {t('common.button.goToHome')}
        </Button>
      </MotionContainer>
    </CompactLayout>
  );
}
